export interface Address {
  id: string
  line1: string
  line2: string
  city: string
  state: string
  zip: string
  country: string
}

export function formatAddress(address: Address | null | undefined): string {
  if (!address) return '-'
  const parts = [address.line1, address.line2, address.city, address.state, address.zip].filter(Boolean)
  return parts.join(', ')
}
